import cx from 'classnames';
import React from 'react';

import Button from '@material-ui/core/Button';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';

import styles from './style.module.scss';

type MessageBoxType = {
  messageText: string;
  showButton: boolean;
  buttonLink?: string;
  buttonText?: string;
  className?: string;
};

export const MessageBox: React.FC<MessageBoxType> = ({
  messageText,
  showButton,
  buttonLink,
  buttonText,
  className,
}) => {
  return (
    <div className={cx(styles.container, className)}>
      <div className={styles.icon}>
        <ReportProblemOutlinedIcon />
      </div>
      <div className={styles.messageBox}>{messageText}</div>

      {showButton && buttonLink && buttonText && (
        <div className={styles.buttonContainer}>
          <Button href={buttonLink} className={styles.link}>
            {buttonText}
          </Button>
        </div>
      )}
    </div>
  );
};
